import axiosClient from "./axiosClient";

// Build query string từ object, bỏ field rỗng/null.
function qs(params?: Record<string, any>): string {
    const entries = params
        ? Object.entries(params).filter(([, v]) => v != null && v !== "")
        : [];
    return entries.length ? "?" + entries.map(([k, v]) => `${k}=${encodeURIComponent(v)}`).join("&") : "";
}

// Admin log viewer — khớp GET /api/v1/admin/logs/{stats,errors,clicks,access}
const logApi = {
    // Số liệu tổng quan toàn cục cho badge đếm trên tab
    getStats() {
        return axiosClient.get(`/admin/logs/stats`);
    },
    // Giá trị lọc có thật trong DB (thay vì hardcode option ở FE)
    getFilterOptions() {
        return axiosClient.get(`/admin/logs/filter-options`);
    },
    // Gom nhóm lỗi trùng theo (loại, status, method, path) — nhiều nhất trước
    getErrorGroups(params?: Record<string, any>) {
        return axiosClient.get(`/admin/logs/errors/groups${qs(params)}`);
    },
    // Dữ liệu biểu đồ theo mốc thời gian. type: "errors" | "clicks" | "access"
    getTimeline(type: string, params?: Record<string, any>) {
        return axiosClient.get(`/admin/logs/${type}/timeline${qs(params)}`);
    },
    // Stat card theo bộ lọc hiện tại (đổi filter → card đổi theo)
    getErrorStats(params?: Record<string, any>) {
        return axiosClient.get(`/admin/logs/errors/stats${qs(params)}`);
    },
    getClickStats(params?: Record<string, any>) {
        return axiosClient.get(`/admin/logs/clicks/stats${qs(params)}`);
    },
    getAccessStats(params?: Record<string, any>) {
        return axiosClient.get(`/admin/logs/access/stats${qs(params)}`);
    },
    // filter: error_type, status_code, is_critical, method, ip, q, from, to, page, limit
    getErrors(params?: Record<string, any>) {
        return axiosClient.get(`/admin/logs/errors${qs(params)}`);
    },
    // filter: platform, channel, source, os, userId, clickId, ip, from, to, page, limit
    getClicks(params?: Record<string, any>) {
        return axiosClient.get(`/admin/logs/clicks${qs(params)}`);
    },
    // filter: resource, action, user_id, ref_id, ip, from, to, page, limit
    getAccess(params?: Record<string, any>) {
        return axiosClient.get(`/admin/logs/access${qs(params)}`);
    },

    // Xoá nhiều dòng theo danh sách id (axios DELETE kèm body)
    deleteErrors(ids: number[]) {
        return axiosClient.delete(`/admin/logs/errors`, { data: { ids } });
    },
    deleteClicks(ids: number[]) {
        return axiosClient.delete(`/admin/logs/clicks`, { data: { ids } });
    },
    deleteAccess(ids: number[]) {
        return axiosClient.delete(`/admin/logs/access`, { data: { ids } });
    },

    // Xoá TẤT CẢ dòng khớp bộ lọc hiện tại (filter qua query, không kèm page/limit)
    deleteAllErrors(params?: Record<string, any>) {
        return axiosClient.delete(`/admin/logs/errors/all${qs(params)}`);
    },
    deleteAllClicks(params?: Record<string, any>) {
        return axiosClient.delete(`/admin/logs/clicks/all${qs(params)}`);
    },
    deleteAllAccess(params?: Record<string, any>) {
        return axiosClient.delete(`/admin/logs/access/all${qs(params)}`);
    },

    // Danh sách chặn IP (CHỈ admin). Server tự từ chối IP hệ thống và IP của chính
    // người đang thao tác — xem backend/src/utils/protected-ips.js.
    getBlockedIps() {
        return axiosClient.get(`/admin/logs/blocked-ips`);
    },
    blockIp(ip: string, note?: string) {
        return axiosClient.post(`/admin/logs/blocked-ips`, { ip, note });
    },
    unblockIp(ip: string) {
        return axiosClient.delete(`/admin/logs/blocked-ips/${encodeURIComponent(ip)}`);
    },

    // Xuất TOÀN BỘ kết quả lọc ra CSV (server stream, không giới hạn 1 trang).
    // type: "errors" | "clicks" | "access".
    exportCsv(type: string, params?: Record<string, any>) {
        return axiosClient.get(`/admin/logs/${type}/export${qs(params)}`, {
            responseType: "blob",
        });
    },
};

export default logApi;
